import type { PayloadAction } from '@reduxjs/toolkit';

import { ExtraReducerBuilder } from '../../types/shared';
import { WritableQuoteBuilderStateType } from '../../types/state';
import { createConfiguredPart } from '../endpoints/create-configured-part';
import { transformSnapQuoteLineToStoreState } from '../utilities/transform-quote-line';
import { withSaveStateUpdate } from '../utilities/with-save-state-update';

function createSnapQuoteLineFulfilledBase(
  state: WritableQuoteBuilderStateType,
  action: PayloadAction<typeof createConfiguredPart.Types.ResultType>,
) {
  const { quoteLine, uuid } = transformSnapQuoteLineToStoreState(
    action.payload,
    state,
  );

  const { lineNumber } = quoteLine;

  // maintain lineNumber order when inserting the new quote line
  state.quoteLineUuids.splice(lineNumber - 1, 0, uuid);
  state.quoteLines[uuid] = quoteLine;
}

const createSnapQuoteLineFulfilled = withSaveStateUpdate(
  createSnapQuoteLineFulfilledBase,
);

export function createSnapQuoteLineReducer(builder: ExtraReducerBuilder) {
  builder.addMatcher(
    createConfiguredPart.matchFulfilled,
    createSnapQuoteLineFulfilled,
  );
}
